class AnchorDirective {
    constructor($window, $location) {
        this.restrict = 'A';
        this.$window = $window;
        this.$location = $location;
        this.scope = {};
    }

    link(scope, element) {
        scope.elementHash = element[0].hash;

        scope.$on('$locationChangeSuccess', () => {
            element[0].setAttribute('href', this.$window.location.pathname + scope.elementHash);
        })
    }

    static directiveFactory($window, $location) {
        'ngInject';
        return new AnchorDirective($window, $location);
    }
}

export default AnchorDirective;
